/**
 * Bundle Loader Component
 *
 * @package
 */

import { useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';

const BundleLoader = ( {
	bundleId,
	setSelectedBaseModel,
	setSelectedProducts,
	setSelectedBundle,
} ) => {
	useEffect( () => {
		if ( ! bundleId ) {
			return;
		}

		apiFetch( {
			path: `/wp/v2/bundles/${ bundleId }`,
		} )
			.then( bundleData => {
				if ( bundleData?.acf ) {
					const vehicleConfigId = bundleData.acf.vehicle_config;
					const baseModelIndex = bundleData.acf.base_model_index;

					if ( vehicleConfigId && baseModelIndex !== undefined ) {
						apiFetch( {
							path: `/wp/v2/vehicle-configs/${ vehicleConfigId }`,
						} )
							.then( vehicleConfig => {
								const baseModels = vehicleConfig?.acf?.base_models || [];
								if ( baseModels[ baseModelIndex ] ) {
									setSelectedBaseModel( baseModels[ baseModelIndex ] );
								}
							} )
							.catch( error => {
							// eslint-disable-next-line no-console
								console.error( 'Failed to fetch vehicle config for bundle:', error );
							} );
					}

					if ( bundleData.acf.selected_optionals ) {
						setSelectedProducts( bundleData.acf.selected_optionals );
					}

					setSelectedBundle( bundleId );
				}
			} )
			.catch( error => {
			// eslint-disable-next-line no-console
				console.error( 'Failed to load bundle:', error );
			} );
	}, [ bundleId, setSelectedBaseModel, setSelectedProducts, setSelectedBundle ] );

	return null;
};

export default BundleLoader;
